export const verificationTimeHours = 48;

export const maxInputLength = 100; //TODO Limit input fields like email and password to very long strings on client and server